export default "/images/16187dc2ba259efbd7ca0254911f5fe0.avif";